import React from 'react';

const LandingLogoSmall = ({ width = 28, height = 28, color = '#DCF31C' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.63816 23.7735H22.9035C26.3213 23.7735 28 21.659 28 17.4291C28 13.2254 26.3519 11.3831 22.5745 11.3831H19.1568C16.0691 11.3831 14.7193 12.723 14.7193 15.7907C14.7193 18.8583 16.0691 20.2004 19.1568 20.2004H22.4243C23.0537 20.2004 23.3838 20.5282 23.3838 21.1535C23.3838 21.7788 23.0537 22.1067 22.4243 22.1067H5.45614C4.82675 22.1067 4.49671 21.7788 4.49671 21.1535C4.49671 20.5282 4.82675 20.2004 5.45614 20.2004H10.4923C12.3213 20.2004 13.1305 19.3964 13.1305 17.5793C13.1305 15.7623 12.3213 14.9583 10.4923 14.9583H5.45614C4.82675 14.9583 4.49671 14.6305 4.49671 14.0052C4.49671 13.3799 4.82675 13.052 5.45614 13.052H8.69407C11.7818 13.052 13.1305 11.712 13.1305 8.6444C13.1305 5.57675 11.7786 4.22632 8.69407 4.22632H2.63816C0.809218 4.22632 0 5.03027 0 6.84732C0 8.66437 0.809218 9.46832 2.63816 9.46832H7.70397C8.33865 9.46832 8.66339 9.79621 8.66339 10.4215C8.66339 11.0468 8.33336 11.3747 7.70397 11.3747H2.63816C0.809218 11.3747 0 12.1787 0 13.9957C0 15.8127 0.809218 16.6167 2.63816 16.6167H7.70397C8.33865 16.6167 8.66339 16.9446 8.66339 17.5699C8.66339 18.1952 8.33336 18.5231 7.70397 18.5231H2.63816C0.809218 18.5231 0 19.327 0 21.1441C0 22.9611 0.809218 23.7735 2.63816 23.7735Z"
      fill={color}
    />
  </svg>
);

export default LandingLogoSmall;
